@if (!hideHeader) {
  <ftr-table-column-header [columns]="columns" [verticalBreakpoint]="verticalBreakpoint"></ftr-table-column-header>
}
@for (item of items; track item) {
  <div
    class="table-body"
    [attr.data-id]="item.id"
    [routerLink]="routerLinkFn ? routerLinkFn(item) : undefined"
    [ngClass]="getRowClasses()"
  >
    @for (column of columns; track column; let i = $index) {
      <div class="table-body__row" [ngClass]="getColumnClasses(column)">
        <span class="table-body__heading">{{ column.name }}</span>
        <ftr-table-cell
          class="table-body__cell"
          [ngClass]="'table-body__cell__' + column.alignment + ' table-body__cell__' + verticalBreakpoint"
          [columnName]="column.name"
          [cell]="column.getCell(item)"
          [cellType]="column.type"
          [verticalBreakpoint]="verticalBreakpoint"
        ></ftr-table-cell>
      </div>
    }
  </div>
}
